//  import React, { useState } from "react";

// export default function Login() {
//   const [phone, setPhone] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", ""]);

//   const handleContinue = () => {
//     if (phone.length === 10) {
//       setShowOtp(true);
//     }
//   };

//   const handleOtp = (value, index) => {
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     if (value && index < 3) {
//       document.getElementById(`otp-${index + 1}`).focus();
//     }
//   };

//   return (
//     <>
//       <style>{`
//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f5f7fb;
//         }

//         .login-page{
//           min-height:100vh;
//           display:flex;
//           flex-wrap:wrap;
//         }

//         /* LEFT SIDE */

//         .left-section{
//           flex:1;
//           min-width:320px;
//           background:
//           linear-gradient(rgba(0,0,0,0.65),rgba(0,0,0,0.7)),
//           url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop');
//           background-size:cover;
//           background-position:center;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           padding:60px;
//           position:relative;
//         }

//         .content{
//           color:white;
//           max-width:550px;
//           z-index:2;
//         }

//         .content h1{
//           font-size:64px;
//           font-weight:800;
//           line-height:1;
//           margin-bottom:10px;
//         }

//         .content h2{
//           font-size:40px;
//           color:#ffb703;
//           margin-bottom:25px;
//           font-weight:700;
//         }

//         .content p{
//           font-size:18px;
//           line-height:1.8;
//           color:#ddd;
//           margin-bottom:40px;
//         }

//         .features{
//           display:flex;
//           gap:20px;
//           flex-wrap:wrap;
//         }

//         .feature-card{
//           background:rgba(255,255,255,0.12);
//           backdrop-filter:blur(12px);
//           border:1px solid rgba(255,255,255,0.15);
//           border-radius:20px;
//           padding:25px;
//           width:140px;
//           text-align:center;
//           transition:0.3s;
//         }

//         .feature-card:hover{
//           transform:translateY(-8px);
//           background:rgba(255,255,255,0.18);
//         }

//         .feature-card span{
//           font-size:40px;
//           display:block;
//           margin-bottom:10px;
//         }

//         .feature-card h4{
//           font-size:17px;
//           font-weight:600;
//         }

//         /* RIGHT SIDE */

//         .right-section{
//           flex:1;
//           min-width:320px;
//           display:flex;
//           justify-content:center;
//           align-items:center;
//           background:#f7f8fc;
//           padding:40px;
//         }

//         .login-card{
//           width:100%;
//           max-width:480px;
//           background:white;
//           border-radius:35px;
//           padding:50px;
//           box-shadow:0 20px 60px rgba(0,0,0,0.08);
//         }

//         .logo-box{
//           width:95px;
//           height:95px;
//           margin:auto;
//           background:#fff4eb;
//           border-radius:25px;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           margin-bottom:25px;
//         }

//         .logo-box img{
//           width:55px;
//         }

//         .welcome{
//           text-align:center;
//           margin-bottom:35px;
//         }

//         .welcome h2{
//           font-size:34px;
//           color:#111;
//           margin-bottom:10px;
//           font-weight:800;
//         }

//         .welcome p{
//           color:#666;
//           line-height:1.7;
//           font-size:15px;
//         }

//         .input-box{
//           margin-bottom:25px;
//         }

//         .input-box label{
//           display:block;
//           margin-bottom:12px;
//           font-size:15px;
//           color:#333;
//           font-weight:600;
//         }

//         .phone-input{
//           display:flex;
//           align-items:center;
//           border:2px solid #eee;
//           border-radius:18px;
//           overflow:hidden;
//           height:65px;
//           transition:0.3s;
//         }

//         .phone-input:focus-within{
//           border-color:#ff8c42;
//           box-shadow:0 0 0 4px rgba(255,140,66,0.15);
//         }

//         .country{
//           width:90px;
//           text-align:center;
//           font-weight:700;
//           color:#444;
//           border-right:1px solid #eee;
//         }

//         .phone-input input{
//           flex:1;
//           border:none;
//           outline:none;
//           padding:0 20px;
//           font-size:18px;
//           font-weight:600;
//         }

//         .continue-btn{
//           width:100%;
//           height:65px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//           margin-top:10px;
//         }

//         .continue-btn:hover{
//           transform:translateY(-3px);
//           box-shadow:0 15px 30px rgba(255,94,98,0.3);
//         }

//         .otp-section{
//           animation:fade 0.4s ease;
//         }

//         .otp-boxes{
//           display:flex;
//           justify-content:center;
//           gap:15px;
//           margin:30px 0;
//         }

//         .otp-boxes input{
//           width:65px;
//           height:70px;
//           border-radius:18px;
//           border:2px solid #eee;
//           text-align:center;
//           font-size:28px;
//           font-weight:700;
//           transition:0.3s;
//         }

//         .otp-boxes input:focus{
//           border-color:#ff8c42;
//           box-shadow:0 0 0 4px rgba(255,140,66,0.15);
//           outline:none;
//         }

//         .verify-btn{
//           width:100%;
//           height:65px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#00b894,#00cec9);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .verify-btn:hover{
//           transform:translateY(-3px);
//           box-shadow:0 15px 30px rgba(0,206,201,0.3);
//         }

//         .bottom-text{
//           text-align:center;
//           margin-top:25px;
//           font-size:14px;
//           color:#777;
//           line-height:1.7;
//         }

//         @keyframes fade{
//           from{
//             opacity:0;
//             transform:translateY(20px);
//           }
//           to{
//             opacity:1;
//             transform:translateY(0);
//           }
//         }

//         @media(max-width:900px){

//           .login-page{
//             flex-direction:column;
//           }

//           .left-section{
//             min-height:420px;
//             padding:40px 25px;
//           }

//           .content h1{
//             font-size:42px;
//           }

//           .content h2{
//             font-size:28px;
//           }

//           .login-card{
//             padding:35px 25px;
//           }

//           .otp-boxes input{
//             width:55px;
//             height:60px;
//           }
//         }

//       `}</style>

//       <div className="login-page">

//         {/* LEFT SIDE */}

//         <div className="left-section">
//           <div className="content">

//             <h1>Smart Loyalty</h1>
//             <h2>& Feedback Ecosystem</h2>

//             <p>
//               QR Scan based smart restaurant loyalty system with rewards,
//               feedback, live visit tracking and customer engagement.
//             </p>

//             <div className="features">

//               <div className="feature-card">
//                 <span>📍</span>
//                 <h4>Live Visit</h4>
//               </div>

//               <div className="feature-card">
//                 <span>🎁</span>
//                 <h4>Rewards</h4>
//               </div>

//               <div className="feature-card">
//                 <span>⭐</span>
//                 <h4>Feedback</h4>
//               </div>

//             </div>
//           </div>
//         </div>

//         {/* RIGHT SIDE */}

//         <div className="right-section">

//           <div className="login-card">

//             <div className="logo-box">
//               <img
//                 src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
//                 alt=""
//               />
//             </div>

//             {!showOtp ? (
//               <>
//                 <div className="welcome">
//                   <h2>Welcome Back</h2>

//                   <p>
//                     Enter your mobile number to continue your loyalty journey.
//                   </p>
//                 </div>

//                 <div className="input-box">
//                   <label>Mobile Number</label>

//                   <div className="phone-input">
//                     <div className="country">+91</div>

//                     <input
//                       type="tel"
//                       maxLength={10}
//                       placeholder="Enter Number"
//                       value={phone}
//                       onChange={(e) =>
//                         setPhone(e.target.value.replace(/\\D/g, ""))
//                       }
//                     />
//                   </div>
//                 </div>

//                 <button
//                   className="continue-btn"
//                   onClick={handleContinue}
//                 >
//                   Continue
//                 </button>
//               </>
//             ) : (
//               <div className="otp-section">

//                 <div className="welcome">
//                   <h2>OTP Verification</h2>

//                   <p>
//                     Enter verification code sent on +91 {phone}
//                   </p>
//                 </div>

//                 <div className="otp-boxes">
//                   {otp.map((digit, index) => (
//                     <input
//                       key={index}
//                       id={`otp-${index}`}
//                       type="text"
//                       maxLength={1}
//                       value={digit}
//                       onChange={(e) =>
//                         handleOtp(e.target.value, index)
//                       }
//                     />
//                   ))}
//                 </div>

//                 <button className="verify-btn">
//                   Verify & Continue
//                 </button>

//               </div>
//             )}

//             <div className="bottom-text">
//               Secure dine-in verification system with rewards,
//               customer loyalty and live restaurant engagement.
//             </div>

//           </div>

//         </div>

//       </div>
//     </>
//   );
// }


// import React, { useState } from "react";

// export default function Login() {

//   const [phone, setPhone] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", ""]);

//   const handleContinue = () => {

//     if (phone.length === 10) {
//       setShowOtp(true);
//     }

//   };

//   const handleOtp = (value, index) => {

//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;

//     setOtp(newOtp);

//     if (value && index < 3) {

//       document
//         .getElementById(`otp-${index + 1}`)
//         ?.focus();

//     }

//   };

//   return (
//     <div className="login-page">

//       <style>{`

//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f5f7fb;
//         }

//         .login-page{
//           min-height:100vh;
//           display:flex;
//           flex-wrap:wrap;
//         }

//         /* LEFT SIDE */

//         .left-section{
//           flex:1;
//           min-width:320px;
//           position:relative;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           overflow:hidden;
//           padding:60px;

//           background:
//           url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop');

//           background-size:cover;
//           background-position:center;
//         }

//         .overlay{
//           position:absolute;
//           inset:0;

//           background:
//           linear-gradient(
//             rgba(0,0,0,0.75),
//             rgba(0,0,0,0.72)
//           );
//         }

//         .content{
//           position:relative;
//           z-index:2;
//           max-width:550px;
//           color:white;
//         }

//         .content h1{
//           font-size:72px;
//           font-weight:800;
//           line-height:1;
//           margin-bottom:10px;
//         }

//         .content h2{
//           font-size:42px;
//           color:#ffb703;
//           margin-bottom:28px;
//           font-weight:700;
//         }

//         .content p{
//           font-size:18px;
//           color:#e5e7eb;
//           line-height:1.9;
//           margin-bottom:40px;
//         }

//         /* FEATURES */

//         .features{
//           display:flex;
//           gap:20px;
//           flex-wrap:wrap;
//         }

//         .feature-card{
//           width:150px;

//           background:
//           rgba(255,255,255,0.12);

//           backdrop-filter:blur(14px);

//           border:1px solid rgba(255,255,255,0.15);

//           border-radius:24px;

//           padding:26px;

//           text-align:center;

//           transition:0.3s;
//         }

//         .feature-card:hover{
//           transform:translateY(-8px);
//           background:rgba(255,255,255,0.18);
//         }

//         .feature-card span{
//           font-size:42px;
//           display:block;
//           margin-bottom:12px;
//         }

//         .feature-card h4{
//           font-size:17px;
//           font-weight:600;
//         }

//         /* RIGHT SIDE */

//         .right-section{
//           flex:1;
//           min-width:320px;

//           display:flex;
//           align-items:center;
//           justify-content:center;

//           background:
//           linear-gradient(
//             135deg,
//             #fff7ed,
//             #ffffff,
//             #eef4ff
//           );

//           padding:40px;
//         }

//         .login-card{
//           width:100%;
//           max-width:500px;

//           background:white;

//           border-radius:38px;

//           padding:50px;

//           box-shadow:
//           0 25px 60px rgba(0,0,0,0.08);

//           position:relative;
//           overflow:hidden;
//         }

//         .login-card::before{
//           content:'';

//           position:absolute;

//           width:220px;
//           height:220px;

//           background:
//           rgba(255,140,66,0.08);

//           border-radius:50%;

//           top:-80px;
//           right:-80px;
//         }

//         /* LOGO */

//         .logo-box{
//           width:100px;
//           height:100px;

//           margin:auto;

//           border-radius:28px;

//           background:#fff4eb;

//           display:flex;
//           align-items:center;
//           justify-content:center;

//           margin-bottom:28px;

//           position:relative;
//           z-index:2;
//         }

//         .logo-box img{
//           width:58px;
//         }

//         /* WELCOME */

//         .welcome{
//           text-align:center;
//           margin-bottom:35px;
//           position:relative;
//           z-index:2;
//         }

//         .welcome h2{
//           font-size:36px;
//           color:#111827;
//           font-weight:800;
//           margin-bottom:12px;
//         }

//         .welcome p{
//           color:#6b7280;
//           line-height:1.8;
//           font-size:15px;
//         }

//         /* INPUT */

//         .input-box{
//           margin-bottom:25px;
//           position:relative;
//           z-index:2;
//         }

//         .input-box label{
//           display:block;
//           margin-bottom:12px;

//           color:#374151;

//           font-size:15px;
//           font-weight:700;
//         }

//         .phone-input{
//           height:68px;

//           border:2px solid #f1f1f1;

//           border-radius:20px;

//           display:flex;
//           align-items:center;

//           overflow:hidden;

//           transition:0.3s;

//           background:#fafafa;
//         }

//         .phone-input:focus-within{
//           border-color:#ff8c42;

//           box-shadow:
//           0 0 0 4px rgba(255,140,66,0.15);

//           background:white;
//         }

//         .country{
//           width:90px;

//           display:flex;
//           align-items:center;
//           justify-content:center;

//           height:100%;

//           border-right:1px solid #eee;

//           color:#374151;
//           font-weight:700;
//           font-size:16px;
//         }

//         .phone-input input{
//           flex:1;

//           border:none;
//           outline:none;

//           background:transparent;

//           padding:0 20px;

//           font-size:18px;
//           font-weight:600;

//           color:#111827;
//         }

//         /* BUTTON */

//         .continue-btn,
//         .verify-btn{
//           width:100%;
//           height:65px;

//           border:none;

//           border-radius:20px;

//           color:white;

//           font-size:18px;
//           font-weight:700;

//           cursor:pointer;

//           transition:0.3s;

//           position:relative;
//           z-index:2;
//         }

//         .continue-btn{
//           background:
//           linear-gradient(
//             135deg,
//             #ff8c42,
//             #ff5e62
//           );
//         }

//         .verify-btn{
//           background:
//           linear-gradient(
//             135deg,
//             #00b894,
//             #00cec9
//           );
//         }

//         .continue-btn:hover,
//         .verify-btn:hover{
//           transform:translateY(-4px);
//         }

//         /* OTP */

//         .otp-section{
//           animation:fade 0.4s ease;
//           position:relative;
//           z-index:2;
//         }

//         .otp-boxes{
//           display:flex;
//           justify-content:center;
//           gap:15px;

//           margin:35px 0;
//         }

//         .otp-boxes input{
//           width:65px;
//           height:70px;

//           border-radius:20px;

//           border:2px solid #f1f1f1;

//           text-align:center;

//           font-size:30px;
//           font-weight:800;

//           background:#fafafa;

//           transition:0.3s;
//         }

//         .otp-boxes input:focus{
//           outline:none;

//           border-color:#ff8c42;

//           background:white;

//           box-shadow:
//           0 0 0 4px rgba(255,140,66,0.15);
//         }

//         /* BOTTOM */

//         .bottom-text{
//           text-align:center;

//           margin-top:28px;

//           font-size:14px;

//           color:#6b7280;

//           line-height:1.8;

//           position:relative;
//           z-index:2;
//         }

//         /* ANIMATION */

//         @keyframes fade{

//           from{
//             opacity:0;
//             transform:translateY(20px);
//           }

//           to{
//             opacity:1;
//             transform:translateY(0);
//           }

//         }

//         /* MOBILE */

//         @media(max-width:950px){

//           .login-page{
//             flex-direction:column;
//           }

//           .left-section{
//             min-height:420px;
//             padding:40px 25px;
//           }

//           .content h1{
//             font-size:48px;
//           }

//           .content h2{
//             font-size:30px;
//           }

//           .right-section{
//             padding:25px;
//           }

//           .login-card{
//             padding:35px 25px;
//           }

//           .welcome h2{
//             font-size:30px;
//           }

//           .otp-boxes input{
//             width:55px;
//             height:60px;
//           }

//         }

//       `}</style>

//       {/* LEFT */}

//       <div className="left-section">

//         <div className="overlay"></div>

//         <div className="content">

//           <h1>
//             Smart Loyalty
//           </h1>

//           <h2>
//             & Feedback Ecosystem
//           </h2>

//           <p>
//             QR based restaurant loyalty platform with
//             rewards, customer engagement, live visit
//             tracking and smart feedback management.
//           </p>

//           <div className="features">

//             <div className="feature-card">

//               <span>
//                 📍
//               </span>

//               <h4>
//                 Live Visits
//               </h4>

//             </div>

//             <div className="feature-card">

//               <span>
//                 🎁
//               </span>

//               <h4>
//                 Rewards
//               </h4>

//             </div>

//             <div className="feature-card">

//               <span>
//                 ⭐
//               </span>

//               <h4>
//                 Feedback
//               </h4>

//             </div>

//           </div>

//         </div>

//       </div>

//       {/* RIGHT */}

//       <div className="right-section">

//         <div className="login-card">

//           <div className="logo-box">

//             <img
//               src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
//               alt=""
//             />

//           </div>

//           {!showOtp ? (

//             <>

//               <div className="welcome">

//                 <h2>
//                   Welcome Back
//                 </h2>

//                 <p>
//                   Enter your mobile number to continue
//                   your loyalty journey.
//                 </p>

//               </div>

//               <div className="input-box">

//                 <label>
//                   Mobile Number
//                 </label>

//                 <div className="phone-input">

//                   <div className="country">
//                     +91
//                   </div>

//                   <input
//                     type="tel"
//                     maxLength={10}
//                     placeholder="Enter Number"
//                     value={phone}
//                     onChange={(e) =>
//                       setPhone(
//                         e.target.value.replace(/\D/g, "")
//                       )
//                     }
//                   />

//                 </div>

//               </div>

//               <button
//                 className="continue-btn"
//                 onClick={handleContinue}
//               >
//                 Continue
//               </button>

//             </>

//           ) : (

//             <div className="otp-section">

//               <div className="welcome">

//                 <h2>
//                   OTP Verification
//                 </h2>

//                 <p>
//                   Enter verification code sent on
//                   +91 {phone}
//                 </p>

//               </div>

//               <div className="otp-boxes">

//                 {otp.map((digit, index) => (

//                   <input
//                     key={index}
//                     id={`otp-${index}`}
//                     type="text"
//                     maxLength={1}
//                     value={digit}
//                     onChange={(e) =>
//                       handleOtp(
//                         e.target.value,
//                         index
//                       )
//                     }
//                   />

//                 ))}

//               </div>

//               <button className="verify-btn">
//                 Verify & Continue
//               </button>

//             </div>

//           )}

//           <div className="bottom-text">

//             Secure dine-in verification system
//             with rewards, loyalty and customer
//             engagement.

//           </div>

//         </div>

//       </div>

//     </div>
//   );
// }

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function Login() {

//   const navigate = useNavigate();

//   const [phone, setPhone] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const [loading, setLoading] = useState(false);

//   const handleContinue = () => {

//     if (phone.length !== 10) {
//       alert("Enter Valid Mobile Number");
//       return;
//     }

//     setLoading(true);

//     setTimeout(() => {

//       setLoading(false);
//       setShowOtp(true);

//     }, 1200);

//   };

//   const handleOtp = (value, index) => {

//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];

//     newOtp[index] = value;

//     setOtp(newOtp);

//     if (value && index < 3) {

//       document
//         .getElementById(`otp-${index + 1}`)
//         ?.focus();

//     }

//   };

//   const handleVerify = () => {

//     const finalOtp = otp.join("");

//     if (finalOtp.length !== 4) {

//       alert("Enter Complete OTP");
//       return;

//     }

//     setLoading(true);

//     setTimeout(() => {

//       setLoading(false);

//       // NAVIGATE TO DASHBOARD
//       navigate("/visit-dashboard");

//     }, 1500);

//   };

//   return (
//     <div className="login-page">

//       <style>{`

//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f5f7fb;
//         }

//         .login-page{
//           min-height:100vh;
//           display:flex;
//           flex-wrap:wrap;
//         }

//         /* LEFT SIDE */

//         .left-section{
//           flex:1;
//           min-width:320px;
//           position:relative;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           overflow:hidden;
//           padding:60px;

//           background:
//           url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop');

//           background-size:cover;
//           background-position:center;
//         }

//         .overlay{
//           position:absolute;
//           inset:0;

//           background:
//           linear-gradient(
//             rgba(0,0,0,0.75),
//             rgba(0,0,0,0.72)
//           );
//         }

//         .content{
//           position:relative;
//           z-index:2;
//           max-width:550px;
//           color:white;
//         }

//         .content h1{
//           font-size:72px;
//           font-weight:800;
//           line-height:1;
//           margin-bottom:10px;
//         }

//         .content h2{
//           font-size:42px;
//           color:#ffb703;
//           margin-bottom:28px;
//           font-weight:700;
//         }

//         .content p{
//           font-size:18px;
//           color:#e5e7eb;
//           line-height:1.9;
//           margin-bottom:40px;
//         }

//         /* FEATURES */

//         .features{
//           display:flex;
//           gap:20px;
//           flex-wrap:wrap;
//         }

//         .feature-card{
//           width:150px;

//           background:
//           rgba(255,255,255,0.12);

//           backdrop-filter:blur(14px);

//           border:1px solid rgba(255,255,255,0.15);

//           border-radius:24px;

//           padding:26px;

//           text-align:center;

//           transition:0.3s;
//         }

//         .feature-card:hover{
//           transform:translateY(-8px);
//           background:rgba(255,255,255,0.18);
//         }

//         .feature-card span{
//           font-size:42px;
//           display:block;
//           margin-bottom:12px;
//         }

//         .feature-card h4{
//           font-size:17px;
//           font-weight:600;
//         }

//         /* RIGHT SIDE */

//         .right-section{
//           flex:1;
//           min-width:320px;

//           display:flex;
//           align-items:center;
//           justify-content:center;

//           background:
//           linear-gradient(
//             135deg,
//             #fff7ed,
//             #ffffff,
//             #eef4ff
//           );

//           padding:40px;
//         }

//         .login-card{
//           width:100%;
//           max-width:500px;

//           background:white;

//           border-radius:38px;

//           padding:50px;

//           box-shadow:
//           0 25px 60px rgba(0,0,0,0.08);

//           position:relative;
//           overflow:hidden;
//         }

//         .login-card::before{
//           content:'';

//           position:absolute;

//           width:220px;
//           height:220px;

//           background:
//           rgba(255,140,66,0.08);

//           border-radius:50%;

//           top:-80px;
//           right:-80px;
//         }

//         /* LOGO */

//         .logo-box{
//           width:100px;
//           height:100px;

//           margin:auto;

//           border-radius:28px;

//           background:#fff4eb;

//           display:flex;
//           align-items:center;
//           justify-content:center;

//           margin-bottom:28px;

//           position:relative;
//           z-index:2;
//         }

//         .logo-box img{
//           width:58px;
//         }

//         /* WELCOME */

//         .welcome{
//           text-align:center;
//           margin-bottom:35px;
//           position:relative;
//           z-index:2;
//         }

//         .welcome h2{
//           font-size:36px;
//           color:#111827;
//           font-weight:800;
//           margin-bottom:12px;
//         }

//         .welcome p{
//           color:#6b7280;
//           line-height:1.8;
//           font-size:15px;
//         }

//         /* INPUT */

//         .input-box{
//           margin-bottom:25px;
//           position:relative;
//           z-index:2;
//         }

//         .input-box label{
//           display:block;
//           margin-bottom:12px;

//           color:#374151;

//           font-size:15px;
//           font-weight:700;
//         }

//         .phone-input{
//           height:68px;

//           border:2px solid #f1f1f1;

//           border-radius:20px;

//           display:flex;
//           align-items:center;

//           overflow:hidden;

//           transition:0.3s;

//           background:#fafafa;
//         }

//         .phone-input:focus-within{
//           border-color:#ff8c42;

//           box-shadow:
//           0 0 0 4px rgba(255,140,66,0.15);

//           background:white;
//         }

//         .country{
//           width:90px;

//           display:flex;
//           align-items:center;
//           justify-content:center;

//           height:100%;

//           border-right:1px solid #eee;

//           color:#374151;
//           font-weight:700;
//           font-size:16px;
//         }

//         .phone-input input{
//           flex:1;

//           border:none;
//           outline:none;

//           background:transparent;

//           padding:0 20px;

//           font-size:18px;
//           font-weight:600;

//           color:#111827;
//         }

//         /* BUTTON */

//         .continue-btn,
//         .verify-btn{
//           width:100%;
//           height:65px;

//           border:none;

//           border-radius:20px;

//           color:white;

//           font-size:18px;
//           font-weight:700;

//           cursor:pointer;

//           transition:0.3s;

//           position:relative;
//           z-index:2;

//           display:flex;
//           align-items:center;
//           justify-content:center;
//           gap:12px;
//         }

//         .continue-btn{
//           background:
//           linear-gradient(
//             135deg,
//             #ff8c42,
//             #ff5e62
//           );
//         }

//         .verify-btn{
//           background:
//           linear-gradient(
//             135deg,
//             #00b894,
//             #00cec9
//           );
//         }

//         .continue-btn:hover,
//         .verify-btn:hover{
//           transform:translateY(-4px);
//         }

//         /* LOADER */

//         .loader{
//           width:22px;
//           height:22px;
//           border-radius:50%;
//           border:3px solid rgba(255,255,255,0.3);
//           border-top:3px solid white;
//           animation:spin 0.8s linear infinite;
//         }

//         @keyframes spin{

//           100%{
//             transform:rotate(360deg);
//           }

//         }

//         /* OTP */

//         .otp-section{
//           animation:fade 0.4s ease;
//           position:relative;
//           z-index:2;
//         }

//         .otp-boxes{
//           display:flex;
//           justify-content:center;
//           gap:15px;

//           margin:35px 0;
//         }

//         .otp-boxes input{
//           width:65px;
//           height:70px;

//           border-radius:20px;

//           border:2px solid #f1f1f1;

//           text-align:center;

//           font-size:30px;
//           font-weight:800;

//           background:#fafafa;

//           transition:0.3s;
//         }

//         .otp-boxes input:focus{
//           outline:none;

//           border-color:#ff8c42;

//           background:white;

//           box-shadow:
//           0 0 0 4px rgba(255,140,66,0.15);
//         }

//         /* BOTTOM */

//         .bottom-text{
//           text-align:center;

//           margin-top:28px;

//           font-size:14px;

//           color:#6b7280;

//           line-height:1.8;

//           position:relative;
//           z-index:2;
//         }

//         /* ANIMATION */

//         @keyframes fade{

//           from{
//             opacity:0;
//             transform:translateY(20px);
//           }

//           to{
//             opacity:1;
//             transform:translateY(0);
//           }

//         }

//         /* MOBILE */

//         @media(max-width:950px){

//           .login-page{
//             flex-direction:column;
//           }

//           .left-section{
//             min-height:420px;
//             padding:40px 25px;
//           }

//           .content h1{
//             font-size:48px;
//           }

//           .content h2{
//             font-size:30px;
//           }

//           .right-section{
//             padding:25px;
//           }

//           .login-card{
//             padding:35px 25px;
//           }

//           .welcome h2{
//             font-size:30px;
//           }

//           .otp-boxes input{
//             width:55px;
//             height:60px;
//           }

//         }

//       `}</style>

//       {/* LEFT */}

//       <div className="left-section">

//         <div className="overlay"></div>

//         <div className="content">

//           <h1>
//             Count My Visit
//           </h1>

//           <h2>
//             & Feedback Ecosystem
//           </h2>

//           <p>
//             QR based restaurant loyalty platform with
//             rewards, customer engagement, live visit
//             tracking and smart feedback management.
//           </p>

//           <div className="features">

//             <div className="feature-card">
//               <span>📍</span>
//               <h4>Live Visits</h4>
//             </div>

//             <div className="feature-card">
//               <span>🎁</span>
//               <h4>Rewards</h4>
//             </div>

//             <div className="feature-card">
//               <span>⭐</span>
//               <h4>Feedback</h4>
//             </div>

//           </div>

//         </div>

//       </div>

//       {/* RIGHT */}

//       <div className="right-section">

//         <div className="login-card">

//           <div className="logo-box">

//             <img
//               src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
//               alt=""
//             />

//           </div>

//           {!showOtp ? (

//             <>

//               <div className="welcome">

//                 <h2>
//                   Welcome Back
//                 </h2>

//                 <p>
//                   Enter your mobile number to continue
//                   your loyalty journey.
//                 </p>

//               </div>

//               <div className="input-box">

//                 <label>
//                   Mobile Number
//                 </label>

//                 <div className="phone-input">

//                   <div className="country">
//                     +91
//                   </div>

//                   <input
//                     type="tel"
//                     maxLength={10}
//                     placeholder="Enter Number"
//                     value={phone}
//                     onChange={(e) =>
//                       setPhone(
//                         e.target.value.replace(/\D/g, "")
//                       )
//                     }
//                   />

//                 </div>

//               </div>

//               <button
//                 className="continue-btn"
//                 onClick={handleContinue}
//               >

//                 {loading ? (
//                   <>
//                     <div className="loader"></div>
//                     Sending OTP...
//                   </>
//                 ) : (
//                   <>
//                     Continue →
//                   </>
//                 )}

//               </button>

//             </>

//           ) : (

//             <div className="otp-section">

//               <div className="welcome">

//                 <h2>
//                   OTP Verification
//                 </h2>

//                 <p>
//                   Enter verification code sent on
//                   +91 {phone}
//                 </p>

//               </div>

//               <div className="otp-boxes">

//                 {otp.map((digit, index) => (

//                   <input
//                     key={index}
//                     id={`otp-${index}`}
//                     type="text"
//                     maxLength={1}
//                     value={digit}
//                     onChange={(e) =>
//                       handleOtp(
//                         e.target.value,
//                         index
//                       )
//                     }
//                   />

//                 ))}

//               </div>

//               <button
//                 className="verify-btn"
//                 onClick={handleVerify}
//               >

//                 {loading ? (
//                   <>
//                     <div className="loader"></div>
//                     Verifying...
//                   </>
//                 ) : (
//                   <>
//                     Verify & Continue →
//                   </>
//                 )}

//               </button>

//             </div>

//           )}

//           <div className="bottom-text">

//             Secure dine-in verification system
//             with rewards, loyalty and customer
//             engagement.

//           </div>

//         </div>

//       </div>

//     </div>
//   );
// }

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const navigate = useNavigate();

//   const [phone, setPhone] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   // Database response ke hisab se OTP ko 6-digits ka kiya hai
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);

//   // --- 1. SEND OTP API CALL ---
//  const handleContinue = () => {
//   if (phone.length !== 10) {
//     alert("Enter Valid Mobile Number");
//     return;
//   }

//   setLoading(true);

//   // FormData ka use karke payload banana sabse sahi aur simple tarika hai
//   const formdata = new FormData();
//   formdata.append("mobilenumber", phone);

//   const requestOptions = {
//     method: "POST",
//     body: formdata, // Isme headers manually set karne ki zaroorat nahi hoti
//     redirect: "follow"
//   };

//   fetch("https://countmyvisit.com/Apis/login.php", requestOptions)
//     .then((response) => response.json()) // JSON parse karna zaroori hai
//     .then((result) => {
//       setLoading(false);
//       if (result.status === "success") {
//         setShowOtp(true);
//       } else {
//         alert(result.message || "Something went wrong");
//       }
//     })
//     .catch((error) => {
//       setLoading(false);
//       console.error("Login Error:", error);
//       alert("Failed to send OTP. Please try again.");
//     });
// };

//   // --- OTP INPUT AUTO-FOCUS HANDLER ---
//   const handleVerify = () => {
//   const finalOtp = otp.join("");

//   if (finalOtp.length !== 6) {
//     alert("Enter Complete 6-Digit OTP");
//     return;
//   }

//   setLoading(true);

//   const formdata = new FormData();
//   formdata.append("mobilenumber", phone);
//   formdata.append("otp", finalOtp);

//   const requestOptions = {
//     method: "POST",
//     body: formdata,
//     redirect: "follow"
//   };

//   // URL query parameter aur body dono mein dynamic OTP pass ho raha hai
//   fetch(`https://countmyvisit.com/Apis/otp_varification.php?otp=${finalOtp}`, requestOptions)
//     .then((response) => response.json()) // `.text()` ki jagah `.json()` kiya taaki data read ho sake
//     .then((result) => {
//       setLoading(false);
      
//       if (result.status === "success") {
//         // Successful verification par data ko next screen par pass kar rahe hain
//         navigate("/visit-dashboard", { state: { user: result.data } });
//       } else {
//         alert(result.message || "Invalid OTP");
//       }
//     })
//     .catch((error) => {
//       setLoading(false);
//       console.error("Verification Error:", error);
//       alert("Verification failed. Please try again.");
//     });
// };

// // OTP Input auto-focus aur state update handler
// const handleOtp = (value, index) => {
//   // Sirf numbers allow karne ke liye
//   if (!/^\d*$/.test(value)) return;

//   const newOtp = [...otp];
//   newOtp[index] = value;
//   setOtp(newOtp);

//   // Agle input box par automatic focus karne ke liye
//   if (value && index < 5) {
//     document.getElementById(`otp-${index + 1}`)?.focus();
//   }
// };
//   return (
//     <div style={styles.loginPage}>
//       {/* LEFT SECTION */}
//       <div style={styles.leftSection}>
//         <div style={styles.overlay}></div>
//         <div style={styles.content}>
//           <h1 style={styles.contentH1}>CountMyVisit</h1>
//           <h2 style={styles.contentH2}>Feedback Ecosystem</h2>
//           <p style={styles.contentP}>
//             QR based restaurant loyalty platform with rewards, customer engagement, live visit tracking and smart feedback management.
//           </p>
//           <div style={styles.features}>
//             <div style={styles.featureCard}>
//               <span style={styles.featureCardSpan}>📍</span>
//               <h4 style={styles.featureCardH4}>Live Visits</h4>
//             </div>
//             <div style={styles.featureCard}>
//               <span style={styles.featureCardSpan}>🎁</span>
//               <h4 style={styles.featureCardH4}>Rewards</h4>
//             </div>
//             <div style={styles.featureCard}>
//               <span style={styles.featureCardSpan}>⭐</span>
//               <h4 style={styles.featureCardH4}>Feedback</h4>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* RIGHT SECTION */}
//       <div style={styles.rightSection}>
//         <div style={styles.loginCard}>
//           <div style={styles.logoBox}>
//             <img
//               src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
//               alt="Logo"
//               style={styles.logoBoxImg}
//             />
//           </div>

//           {!showOtp ? (
//             <>
//               <div style={styles.welcome}>
//                 <h2 style={styles.welcomeH2}>Welcome Back</h2>
//                 <p style={styles.welcomeP}>
//                   Enter your mobile number to continue your loyalty journey.
//                 </p>
//               </div>

//               <div style={styles.inputBox}>
//                 <label style={styles.inputBoxLabel}>Mobile Number</label>
//                 <div style={styles.phoneInput}>
//                   <div style={styles.country}>+91</div>
//                   <input
//                     type="tel"
//                     maxLength={10}
//                     placeholder="Enter Number"
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
//                     style={styles.phoneInputControl}
//                   />
//                 </div>
//               </div>

//               <button style={styles.continueBtn} onClick={handleContinue} disabled={loading}>
//                 {loading ? (
//                   <>
//                     <div style={styles.loader}></div>
//                     Sending OTP...
//                   </>
//                 ) : (
//                   "Continue →"
//                 )}
//               </button>
//             </>
//           ) : (
//             <div style={styles.otpSection}>
//               <div style={styles.welcome}>
//                 <h2 style={styles.welcomeH2}>OTP Verification</h2>
//                 <p style={styles.welcomeP}>Enter verification code sent on +91 {phone}</p>
//               </div>

//               <div style={styles.otpBoxes}>
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     id={`otp-${index}`}
//                     type="text"
//                     maxLength={1}
//                     value={digit}
//                     onChange={(e) => handleOtp(e.target.value, index)}
//                     style={styles.otpInputControl}
//                   />
//                 ))}
//               </div>

//               <button style={styles.verifyBtn} onClick={handleVerify} disabled={loading}>
//                 {loading ? (
//                   <>
//                     <div style={styles.loader}></div>
//                     Verifying...
//                   </>
//                 ) : (
//                   "Verify & Continue →"
//                 )}
//               </button>
//             </div>
//           )}

//           <div style={styles.bottomText}>
//             Secure dine-in verification system with rewards, loyalty and customer engagement.
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // --- REACT NATIVE STYLE STYLESHEET OBJECT ---
// const styles = {
//   loginPage: {
//     minHeight: "100vh",
//     display: "flex",
//     flexWrap: "wrap",
//     fontFamily: "'Poppins', sans-serif",
//     backgroundColor: "#f5f7fb",
//     margin: 0,
//     padding: 0,
//     boxSizing: "border-box"
//   },
//   leftSection: {
//     flex: 1,
//     minWidth: "320px",
//     position: "relative",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     overflow: "hidden",
//     padding: "60px",
//     backgroundImage: "url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop')",
//     backgroundSize: "cover",
//     backgroundPosition: "center"
//   },
//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.72))"
//   },
//   content: {
//     position: "relative",
//     zIndex: 2,
//     maxWidth: "550px",
//     color: "white"
//   },
//   contentH1: {
//     fontSize: "72px",
//     fontWeight: 800,
//     lineHeight: 1,
//     marginBottom: "10px"
//   },
//   contentH2: {
//     fontSize: "42px",
//     color: "#ffb703",
//     marginBottom: "28px",
//     fontWeight: 700
//   },
//   contentP: {
//     fontSize: "18px",
//     color: "#e5e7eb",
//     lineHeight: 1.9,
//     marginBottom: "40px"
//   },
//   features: {
//     display: "flex",
//     gap: "20px",
//     flexWrap: "wrap"
//   },
//   featureCard: {
//     width: "150px",
//     background: "rgba(255,255,255,0.12)",
//     backdropFilter: "blur(14px)",
//     border: "1px solid rgba(255,255,255,0.15)",
//     borderRadius: "24px",
//     padding: "26px",
//     textAlign: "center"
//   },
//   featureCardSpan: {
//     fontSize: "42px",
//     display: "block",
//     marginBottom: "12px"
//   },
//   featureCardH4: {
//     fontSize: "17px",
//     fontWeight: 600
//   },
//   rightSection: {
//     flex: 1,
//     minWidth: "320px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "linear-gradient(135deg, #fff7ed, #ffffff, #eef4ff)",
//     padding: "40px"
//   },
//   loginCard: {
//     width: "100%",
//     maxWidth: "500px",
//     background: "white",
//     borderRadius: "38px",
//     padding: "50px",
//     boxShadow: "0 25px 60px rgba(0,0,0,0.08)",
//     position: "relative",
//     overflow: "hidden"
//   },
//   logoBox: {
//     width: "100px",
//     height: "100px",
//     margin: "0 auto 28px auto",
//     borderRadius: "28px",
//     background: "#fff4eb",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     position: "relative",
//     zIndex: 2
//   },
//   logoBoxImg: {
//     width: "58px"
//   },
//   welcome: {
//     textAlign: "center",
//     marginBottom: "35px",
//     position: "relative",
//     zIndex: 2
//   },
//   welcomeH2: {
//     fontSize: "36px",
//     color: "#111827",
//     fontWeight: 800,
//     marginBottom: "12px"
//   },
//   welcomeP: {
//     color: "#6b7280",
//     lineHeight: 1.8,
//     fontSize: "15px"
//   },
//   inputBox: {
//     marginBottom: "25px",
//     position: "relative",
//     zIndex: 2
//   },
//   inputBoxLabel: {
//     display: "block",
//     marginBottom: "12px",
//     color: "#374151",
//     fontSize: "15px",
//     fontWeight: 700
//   },
//   phoneInput: {
//     height: "68px",
//     border: "2px solid #f1f1f1",
//     borderRadius: "20px",
//     display: "flex",
//     alignItems: "center",
//     overflow: "hidden",
//     background: "#fafafa"
//   },
//   country: {
//     width: "90px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "100%",
//     borderRight: "1px solid #eee",
//     color: "#374151",
//     fontWeight: 700,
//     fontSize: "16px"
//   },
//   phoneInputControl: {
//     flex: 1,
//     border: "none",
//     outline: "none",
//     background: "transparent",
//     padding: "0 20px",
//     fontSize: "18px",
//     fontWeight: 600,
//     color: "#111827"
//   },
//   continueBtn: {
//     width: "100%",
//     height: "65px",
//     border: "none",
//     borderRadius: "20px",
//     color: "white",
//     fontSize: "18px",
//     fontWeight: 700,
//     cursor: "pointer",
//     position: "relative",
//     zIndex: 2,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "12px",
//     background: "linear-gradient(135deg, #ff8c42, #ff5e62)"
//   },
//   verifyBtn: {
//     width: "100%",
//     height: "65px",
//     border: "none",
//     borderRadius: "20px",
//     color: "white",
//     fontSize: "18px",
//     fontWeight: 700,
//     cursor: "pointer",
//     position: "relative",
//     zIndex: 2,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "12px",
//     background: "linear-gradient(135deg, #00b894, #00cec9)"
//   },
//   loader: {
//     width: "22px",
//     height: "22px",
//     borderRadius: "50%",
//     border: "3px solid rgba(255,255,255,0.3)",
//     borderTop: "3px solid white",
//     animation: "spin 0.8s linear infinite"
//   },
//   otpSection: {
//     position: "relative",
//     zIndex: 2
//   },
//   otpBoxes: {
//     display: "flex",
//     justifyContent: "center",
//     gap: "10px", // 6 boxes ke liye gap thoda adjust kiya hai
//     margin: "35px 0"
//   },
//   otpInputControl: {
//     width: "45px", // 6 boxes screen par fit aane ke liye width thodi kam ki hai
//     height: "60px",
//     borderRadius: "15px",
//     border: "2px solid #f1f1f1",
//     textAlign: "center",
//     fontSize: "24px",
//     fontWeight: 800,
//     background: "#fafafa"
//   },
//   bottomText: {
//     textAlign: "center",
//     marginTop: "28px",
//     fontSize: "14px",
//     color: "#6b7280",
//     lineHeight: 1.8,
//     position: "relative",
//     zIndex: 2
//   }
// };

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const navigate = useNavigate();

//   const [phone, setPhone] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);

//   // --- 1. SEND OTP API CALL ---
//   const handleContinue = (e) => {
//     if (e) e.preventDefault();

//     if (phone.length !== 10) {
//       alert("Enter Valid Mobile Number");
//       return;
//     }

//     setLoading(true);

//     const formdata = new FormData();
//     formdata.append("mobilenumber", phone);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/login.php", requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         setLoading(false);
//         if (result.status === "success") {
//           setShowOtp(true);
//         } else {
//           alert(result.message || "Something went wrong");
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Login Error:", error);
//         alert("Failed to send OTP. Please try again.");
//       });
//   };

//   // --- 2. VERIFY OTP API CALL ---
//   const handleVerify = (e) => {
//     if (e) e.preventDefault();
//     const finalOtp = otp.join("");

//     if (finalOtp.length !== 6) {
//       alert("Enter Complete 6-Digit OTP");
//       return;
//     }

//     setLoading(true);

//     const formdata = new FormData();
//     formdata.append("mobilenumber", phone);
//     formdata.append("otp", finalOtp);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`https://countmyvisit.com/Apis/otp_varification.php?otp=${finalOtp}`, requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         setLoading(false);
//         if (result.status === "success") {
//           navigate("/visit-dashboard", { state: { user: result.data } });
//         } else {
//           alert(result.message || "Invalid OTP");
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Verification Error:", error);
//         alert("Verification failed. Please try again.");
//       });
//   };

//   // OTP Input handler with auto-focus forward
//   const handleOtp = (value, index) => {
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value.slice(-1); // Keep last typed digit
//     setOtp(newOtp);

//     if (value && index < 5) {
//       document.getElementById(`otp-${index + 1}`)?.focus();
//     }
//   };

//   // Backspace key handler to shift focus backward
//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       document.getElementById(`otp-${index - 1}`)?.focus();
//     }
//   };

//   return (
//     <div className="login-page">
//       <style>{`
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//           font-family: 'Poppins', sans-serif;
//         }

//         body {
//           background: #f8fafc;
//         }

//         .login-page {
//           min-height: 100vh;
//           width: 100%;
//           display: grid;
//           grid-template-columns: 1.1fr 0.9fr;
//         }

//         /* LEFT SCREEN PANEL */
//         .left-section {
//           position: relative;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 40px;
//           background: url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop');
//           background-size: cover;
//           background-position: center;
//         }

//         .overlay {
//           position: absolute;
//           inset: 0;
//           background: linear-gradient(
//             135deg,
//             rgba(15, 23, 42, 0.9),
//             rgba(30, 41, 59, 0.85)
//           );
//         }

//         .content {
//           position: relative;
//           z-index: 2;
//           max-width: 520px;
//           color: white;
//         }

//         .content h1 {
//           font-size: clamp(34px, 4vw, 54px);
//           font-weight: 800;
//           line-height: 1.1;
//           margin-bottom: 8px;
//           letter-spacing: -1px;
//         }

//         .content h2 {
//           font-size: clamp(22px, 2.5vw, 32px);
//           color: #f97316;
//           margin-bottom: 24px;
//           font-weight: 700;
//         }

//         .content p {
//           font-size: clamp(15px, 1.2vw, 17px);
//           color: #cbd5e1;
//           line-height: 1.7;
//           margin-bottom: 40px;
//         }

//         /* PLATFORM VALUE HIGHLIGHTS */
//         .features {
//           display: flex;
//           gap: 16px;
//         }

//         .feature-card {
//           flex: 1;
//           background: rgba(255, 255, 255, 0.08);
//           backdrop-filter: blur(12px);
//           -webkit-backdrop-filter: blur(12px);
//           border: 1px solid rgba(255, 255, 255, 0.12);
//           border-radius: 20px;
//           padding: 22px 12px;
//           text-align: center;
//           transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//         }

//         .feature-card:hover {
//           transform: translateY(-4px);
//           background: rgba(255, 255, 255, 0.14);
//           border-color: rgba(255, 255, 255, 0.25);
//         }

//         .feature-card span {
//           font-size: 32px;
//           display: block;
//           margin-bottom: 8px;
//         }

//         .feature-card h4 {
//           font-size: 14px;
//           font-weight: 600;
//           color: #f8fafc;
//         }

//         /* RIGHT FLOW PANEL */
//         .right-section {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: #f8fafc;
//           padding: 40px 24px;
//         }

//         .login-card {
//           width: 100%;
//           max-width: 480px;
//           background: white;
//           border-radius: 32px;
//           padding: 44px;
//           box-shadow: 0 20px 40px rgba(15, 23, 42, 0.06);
//         }

//         /* BRAND DISPLAY LOGO HEADER */
//         .logo-box {
//           width: 84px;
//           height: 84px;
//           margin: 0 auto 24px auto;
//           border-radius: 22px;
//           background: #fff7ed;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border: 1px solid #ffedd5;
//         }

//         .logo-box img {
//           width: 46px;
//           height: 46px;
//           object-fit: contain;
//         }

//         /* PANEL INTERACTIVE FONTS */
//         .welcome {
//           text-align: center;
//           margin-bottom: 32px;
//         }

//         .welcome h2 {
//           font-size: 28px;
//           color: #0f172a;
//           font-weight: 700;
//           margin-bottom: 8px;
//           letter-spacing: -0.5px;
//         }

//         .welcome p {
//           color: #64748b;
//           line-height: 1.6;
//           font-size: 14px;
//         }

//         /* FIELD WRAPPERS */
//         .input-box {
//           margin-bottom: 24px;
//         }

//         .input-box label {
//           display: block;
//           margin-bottom: 8px;
//           color: #334155;
//           font-size: 14px;
//           font-weight: 600;
//         }

//         .phone-input {
//           height: 58px;
//           border: 2px solid #e2e8f0;
//           border-radius: 16px;
//           display: flex;
//           align-items: center;
//           overflow: hidden;
//           transition: all 0.25s ease;
//           background: #f8fafc;
//         }

//         .phone-input:focus-within {
//           border-color: #f97316;
//           box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.12);
//           background: white;
//         }

//         .country {
//           width: 75px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           height: 100%;
//           border-right: 1px solid #e2e8f0;
//           color: #475569;
//           font-weight: 600;
//           font-size: 15px;
//           background: #f1f5f9;
//         }

//         .phone-input input {
//           flex: 1;
//           border: none;
//           outline: none;
//           background: transparent;
//           padding: 0 16px;
//           font-size: 17px;
//           font-weight: 600;
//           color: #0f172a;
//           letter-spacing: 0.5px;
//         }

//         /* ACTION SUBMISSION CONTROLS */
//         .submit-btn {
//           width: 100%;
//           height: 56px;
//           border: none;
//           border-radius: 16px;
//           color: white;
//           font-size: 16px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//         }

//         .continue-bg {
//           background: linear-gradient(135deg, #ea580c, #f97316);
//           box-shadow: 0 4px 12px rgba(249, 115, 22, 0.2);
//         }

//         .verify-bg {
//           background: linear-gradient(135deg, #0d9488, #14b8a6);
//           box-shadow: 0 4px 12px rgba(13, 148, 136, 0.2);
//         }

//         .submit-btn:hover:not(:disabled) {
//           transform: translateY(-2px);
//           filter: brightness(1.05);
//         }

//         .submit-btn:active:not(:disabled) {
//           transform: translateY(0);
//         }

//         .submit-btn:disabled {
//           opacity: 0.7;
//           cursor: not-allowed;
//           transform: none !important;
//         }

//         /* ANIMATED LOADER */
//         .loader {
//           width: 20px;
//           height: 20px;
//           border-radius: 50%;
//           border: 2.5px solid rgba(255, 255, 255, 0.3);
//           border-top: 2.5px solid white;
//           animation: spin 0.7s linear infinite;
//         }

//         @keyframes spin {
//           100% { transform: rotate(360deg); }
//         }

//         /* 6 DIGIT OTP CONTAINER MATRIX */
//         .otp-section {
//           animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
//         }

//         .otp-boxes {
//           display: flex;
//           justify-content: space-between;
//           gap: 8px;
//           margin: 28px 0;
//         }

//         .otp-boxes input {
//           flex: 1;
//           height: 54px;
//           max-width: 60px;
//           border-radius: 14px;
//           border: 2px solid #e2e8f0;
//           text-align: center;
//           font-size: 22px;
//           font-weight: 700;
//           background: #f8fafc;
//           color: #0f172a;
//           transition: all 0.2s ease;
//         }

//         .otp-boxes input:focus {
//           outline: none;
//           border-color: #0d9488;
//           background: white;
//           box-shadow: 0 0 0 4px rgba(13, 148, 136, 0.12);
//         }

//         .bottom-text {
//           text-align: center;
//           margin-top: 28px;
//           font-size: 13px;
//           color: #94a3b8;
//           line-height: 1.6;
//         }

//         @keyframes slideUp {
//           from {
//             opacity: 0;
//             transform: translateY(14px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         /* GLOBAL SCREEN MEDIA CONTROLS */
//         @media (max-width: 992px) {
//           .login-page {
//             grid-template-columns: 1fr;
//             grid-template-rows: auto 1fr;
//           }

//           .left-section {
//             padding: 50px 24px;
//             text-align: center;
//           }

//           .features {
//             justify-content: center;
//             max-width: 460px;
//             margin: 0 auto;
//           }
          
//           .feature-card {
//             padding: 16px 8px;
//           }
          
//           .right-section {
//             background: #f8fafc;
//             align-items: flex-start;
//             padding-top: 24px;
//           }

//           .login-card {
//             box-shadow: 0 10px 30px rgba(15, 23, 42, 0.03);
//           }
//         }

//         @media (max-width: 480px) {
//           .login-card {
//             padding: 28px 20px;
//             border-radius: 24px;
//           }
//           .features {
//             gap: 10px;
//           }
//           .feature-card span {
//             font-size: 26px;
//           }
//           .otp-boxes {
//             gap: 6px;
//           }
//           .otp-boxes input {
//             height: 48px;
//             font-size: 18px;
//             border-radius: 10px;
//           }
//         }
//       `}</style>

//       {/* LEFT SECTION PLATFORM INTRO */}
//       <div className="left-section">
//         <div className="overlay"></div>
//         <div className="content">
//           <h1>CountMyVisit</h1>
//           <h2>Feedback Ecosystem</h2>
//           <p>
//             QR based restaurant loyalty platform with rewards, customer engagement, live visit tracking and smart feedback management.
//           </p>
//           <div className="features">
//             <div className="feature-card">
//               <span>📍</span>
//               <h4>Live Visits</h4>
//             </div>
//             <div className="feature-card">
//               <span>🎁</span>
//               <h4>Rewards</h4>
//             </div>
//             <div className="feature-card">
//               <span>⭐</span>
//               <h4>Feedback</h4>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* RIGHT SECTION SECURITY GATEWAY */}
//       <div className="right-section">
//         <div className="login-card">
//           <div className="logo-box">
//             <img
//               src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
//               alt="Platform Core Logo"
//             />
//           </div>

//           {!showOtp ? (
//             <form onSubmit={handleContinue}>
//               <div className="welcome">
//                 <h2>Welcome Back</h2>
//                 <p>Enter your mobile number to continue your loyalty journey.</p>
//               </div>

//               <div className="input-box">
//                 <label htmlFor="mobile-input-field">Mobile Number</label>
//                 <div className="phone-input">
//                   <div className="country">+91</div>
//                   <input
//                     id="mobile-input-field"
//                     type="tel"
//                     maxLength={10}
//                     placeholder="Enter Number"
//                     value={phone}
//                     disabled={loading}
//                     onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
//                   />
//                 </div>
//               </div>

//               <button 
//                 type="submit" 
//                 className="submit-btn continue-bg" 
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <div className="loader"></div>
//                     <span>Sending OTP...</span>
//                   </>
//                 ) : (
//                   <span>Continue →</span>
//                 )}
//               </button>
//             </form>
//           ) : (
//             <form onSubmit={handleVerify} className="otp-section">
//               <div className="welcome">
//                 <h2>OTP Verification</h2>
//                 <p>Enter verification code sent on +91 {phone}</p>
//               </div>

//               <div className="otp-boxes">
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     id={`otp-${index}`}
//                     type="text"
//                     inputMode="numeric"
//                     pattern="[0-9]*"
//                     maxLength={1}
//                     value={digit}
//                     disabled={loading}
//                     onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                     onChange={(e) => handleOtp(e.target.value, index)}
//                   />
//                 ))}
//               </div>

//               <button 
//                 type="submit" 
//                 className="submit-btn verify-bg" 
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <div className="loader"></div>
//                     <span>Verifying...</span>
//                   </>
//                 ) : (
//                   <span>Verify &amp; Continue →</span>
//                 )}
//               </button>
//             </form>
//           )}

//           <div className="bottom-text">
//             Secure dine-in verification system with rewards, loyalty and customer engagement.
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const navigate = useNavigate();

//   const [phone, setPhone] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);

//   // स्ट्रिंग में से "DATABASECONNECTED" को हटाकर शुद्ध JSON पार्स करने के लिए हेल्पर फ़ंक्शन
//   const parseCleanJson = async (response) => {
//     const rawText = await response.text();
//     // अगर रिस्पॉन्स में DATABASECONNECTED है तो उसे हटा दें
//     const cleanText = rawText.replace("DATABASECONNECTED", "").trim();
//     return JSON.parse(cleanText);
//   };

//   // --- 1. SEND OTP API CALL (urlencoded) ---
//   const handleContinue = (e) => {
//     if (e) e.preventDefault();

//     if (phone.length !== 10) {
//       alert("please eneter 10 digit number");
//       return;
//     }

//     setLoading(true);

//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

//     const urlencoded = new URLSearchParams();
//     urlencoded.append("mobilenumber", phone);

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: urlencoded,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/login.php", requestOptions)
//       .then((response) => parseCleanJson(response))
//       .then((result) => {
//         setLoading(false);
//         if (result.status === "success") {
//           setShowOtp(true);
//         } else {
//           alert(result.message || "something went wrong");
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Login Error:", error);
         
//       });
//   };

//   // --- 2. VERIFY OTP API CALL (FormData) ---
//   const handleVerify = (e) => {
//     if (e) e.preventDefault();
//     const finalOtp = otp.join("");

//     if (finalOtp.length !== 6) {
       
//       return;
//     }

//     setLoading(true);

//     const formdata = new FormData();
//     formdata.append("mobilenumber", phone);
//     formdata.append("otp", finalOtp);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/otp_varification.php", requestOptions)
//       .then((response) => parseCleanJson(response))
//       .then((result) => {
//         setLoading(false);
//         if (result.status === "success") {

//     // Save Login Status
//     localStorage.setItem("isLoggedIn", "true");

//     // Save User Data
//     localStorage.setItem(
//         "userData",
//         JSON.stringify(result.data)
//     );
  
//      navigate("/visit-dashboard", { replace: true });
// }else {
//           alert(result.message || "wrong otp");
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Verification Error:", error);
         
//       });
//   };

//    const handleOtp = (value, index) => {
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value.slice(-1);
//     setOtp(newOtp);

//     if (value && index < 5) {
//       document.getElementById(`otp-${index + 1}`)?.focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       document.getElementById(`otp-${index - 1}`)?.focus();
//     }
//   };

//   return (
//     <div className="login-wrapper">
//        <style>{`
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//           font-family: 'Poppins', sans-serif;
//         }

//         body {
//           background: #f8fafc;
//           min-height: 100vh;
//           width: 100%;
//         }

//         .login-wrapper {
//           min-height: 100vh;
//           width: 100%;
//           display: grid;
//           grid-template-columns: 1.1fr 0.9fr;
//         }

//         /* LEFT BRAND PANEL */
//         .left-banner {
//           position: relative;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 40px;
//           background: url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop');
//           background-size: cover;
//           background-position: center;
//         }

//         .banner-overlay {
//           position: absolute;
//           inset: 0;
//           background: linear-gradient(135deg, rgba(15, 23, 42, 0.95), rgba(30, 41, 59, 0.85));
//         }

//         .banner-content {
//           position: relative;
//           z-index: 2;
//           width: 100%;
//           max-width: 500px;
//           color: white;
//         }

//         .banner-content h1 {
//           font-size: clamp(32px, 4vw, 48px);
//           font-weight: 800;
//           line-height: 1.2;
//           margin-bottom: 8px;
//           letter-spacing: -1px;
//         }

//         .banner-content h2 {
//           font-size: clamp(20px, 2.5vw, 28px);
//           color: #f97316;
//           margin-bottom: 20px;
//           font-weight: 700;
//         }

//         .banner-content p {
//           font-size: clamp(14px, 1.5vw, 16px);
//           color: #cbd5e1;
//           line-height: 1.7;
//           margin-bottom: clamp(24px, 4vw, 40px);
//         }

//         .feature-chips {
//           display: flex;
//           gap: 14px;
//           flex-wrap: wrap; /* Prevents squishing on mid-size screens */
//         }

//         .chip {
//           flex: 1;
//           min-width: 120px; /* Ensures chips read well when wrapping */
//           background: rgba(255, 255, 255, 0.06);
//           backdrop-filter: blur(8px);
//           -webkit-backdrop-filter: blur(8px);
//           border: 1px solid rgba(255, 255, 255, 0.1);
//           border-radius: 16px;
//           padding: clamp(12px, 2vw, 20px) 10px;
//           text-align: center;
//           transition: all 0.3s ease;
//         }

//         .chip:hover {
//           transform: translateY(-3px);
//           background: rgba(255, 255, 255, 0.12);
//         }

//         .chip-icon {
//           font-size: clamp(22px, 3vw, 28px);
//           display: block;
//           margin-bottom: 6px;
//         }

//         .chip h4 {
//           font-size: 13px;
//           font-weight: 600;
//           color: #f8fafc;
//         }

//         /* RIGHT FORM PANEL */
//         .right-form-panel {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: #f8fafc;
//           padding: 40px 24px;
//         }

//         .form-card {
//           width: 100%;
//           max-width: 440px;
//           background: white;
//           border-radius: 28px;
//           padding: clamp(24px, 5vw, 40px);
//           box-shadow: 0 20px 40px rgba(15, 23, 42, 0.04);
//           border: 1px solid #f1f5f9;
//         }

//         .logo-container {
//           width: 76px;
//           height: 76px;
//           margin: 0 auto 24px auto;
//           border-radius: 20px;
//           background: #fff7ed;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border: 1px solid #ffedd5;
//         }

//         .logo-container img {
//           width: 42px;
//           height: 42px;
//           object-fit: contain;
//         }

//         .panel-header {
//           text-align: center;
//           margin-bottom: 32px;
//         }

//         .panel-header h2 {
//           font-size: clamp(20px, 3vw, 24px);
//           color: #0f172a;
//           font-weight: 700;
//           margin-bottom: 6px;
//         }

//         .panel-header p {
//           color: #64748b;
//           font-size: 14px;
//         }

//         .input-group {
//           margin-bottom: 24px;
//         }

//         .input-group label {
//           display: block;
//           margin-bottom: 8px;
//           color: #475569;
//           font-size: 13px;
//           font-weight: 600;
//         }

//         .phone-wrapper {
//           height: 54px;
//           border: 2px solid #e2e8f0;
//           border-radius: 14px;
//           display: flex;
//           align-items: center;
//           overflow: hidden;
//           transition: all 0.2s ease;
//           background: #f8fafc;
//         }

//         .phone-wrapper:focus-within {
//           border-color: #f97316;
//           box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1);
//           background: white;
//         }

//         .prefix {
//           padding: 0 14px;
//           color: #475569;
//           font-weight: 600;
//           font-size: 15px;
//           border-right: 1px solid #e2e8f0;
//           height: 100%;
//           display: flex;
//           align-items: center;
//           background: #f1f5f9;
//         }

//         .phone-wrapper input {
//           flex: 1;
//           width: 100%;
//           border: none;
//           outline: none;
//           background: transparent;
//           padding: 0 14px;
//           font-size: 16px;
//           font-weight: 600;
//           color: #0f172a;
//           letter-spacing: 0.5px;
//         }

//         .primary-btn {
//           width: 100%;
//           height: 52px;
//           border: none;
//           border-radius: 14px;
//           color: white;
//           font-size: 15px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//         }

//         .orange-gradient {
//           background: linear-gradient(135deg, #ea580c, #f97316);
//           box-shadow: 0 4px 12px rgba(249, 115, 22, 0.15);
//         }

//         .teal-gradient {
//           background: linear-gradient(135deg, #0d9488, #14b8a6);
//           box-shadow: 0 4px 12px rgba(13, 148, 136, 0.15);
//         }

//         .primary-btn:hover:not(:disabled) {
//           transform: translateY(-1px);
//           filter: brightness(1.03);
//         }

//         .primary-btn:disabled {
//           opacity: 0.65;
//           cursor: not-allowed;
//         }

//         /* LOADING ANIMATION Spinner */
//         .spinner {
//           width: 18px;
//           height: 18px;
//           border-radius: 50%;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-top: 2px solid white;
//           animation: spin 0.6s linear infinite;
//         }

//         @keyframes spin {
//           100% { transform: rotate(360deg); }
//         }

//         /* OTP INPUT BOXES DESIGN */
//         .otp-fade-in {
//           animation: scaleUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
//         }

//         .otp-grid {
//           display: grid;
//           grid-template-columns: repeat(6, 1fr);
//           gap: 8px;
//           margin: 24px 0;
//         }

//         .otp-grid input {
//           height: 50px;
//           width: 100%;
//           border-radius: 12px;
//           border: 2px solid #e2e8f0;
//           text-align: center;
//           font-size: clamp(16px, 4vw, 20px);
//           font-weight: 700;
//           background: #f8fafc;
//           color: #0f172a;
//           transition: all 0.2s ease;
//         }

//         .otp-grid input:focus {
//           outline: none;
//           border-color: #0d9488;
//           background: white;
//           box-shadow: 0 0 0 4px rgba(13, 148, 136, 0.1);
//         }

//         .bottom-credits {
//           text-align: center;
//           margin-top: 32px;
//           font-size: 12px;
//           color: #94a3b8;
//           line-height: 1.5;
//         }

//         @keyframes scaleUp {
//           from { opacity: 0; transform: scale(0.96) translateY(8px); }
//           to { opacity: 1; transform: scale(1) translateY(0); }
//         }

//         /* RESPONSIVE MEDIA QUERIES */
//         @media (max-width: 992px) {
//           .login-wrapper {
//             grid-template-columns: 1fr;
//           }
//           .left-banner {
//             height: 320px; /* Prevent excessive vertical scroll */
//             padding: 30px 20px;
//             text-align: center;
//           }
//           .banner-content {
//             max-width: 600px;
//           }
//           .banner-content p {
//             margin-bottom: 20px;
//           }
//           .feature-chips {
//             justify-content: center;
//             max-width: 460px;
//             margin: 0 auto;
//           }
//           .right-form-panel {
//             padding: 32px 24px;
//           }
//         }

//         @media (max-width: 576px) {
//           .left-banner {
//             height: 220px; /* Minimal header height for tiny devices */
//           }
//           .banner-content h2, .banner-content p, .feature-chips {
//             display: none; /* Hide marketing text on mobile to focus strictly on login form */
//           }
//           .right-form-panel {
//             padding: 16px 12px;
//             background: white; /* Blends form card into screen edge */
//           }
//           .form-card {
//             padding: 24px 16px;
//             border-radius: 20px;
//             box-shadow: none; /* Strip shadow for native application vibe */
//             border: none;
//           }
//           .logo-container {
//             margin-bottom: 16px;
//           }
//           .panel-header {
//             margin-bottom: 24px;
//           }
//           .otp-grid {
//             gap: 4px;
//           }
//           .otp-grid input {
//             height: 44px;
//           }
//         }
//       `}</style>

//       {/* LEFT SECTION */}
//       <div className="left-banner">
//         <div className="banner-overlay"></div>
//         <div className="banner-content">
//           <h1>CountMyVisit</h1>
//           <h2>Feedback Ecosystem</h2>
//           <p>
//             QR based restaurant loyalty platform with rewards, customer engagement, live visit tracking and smart feedback management.
//           </p>
//           <div className="feature-chips">
//             <div className="chip">
//               <span className="chip-icon">📍</span>
//               <h4>Live Visits</h4>
//             </div>
//             <div className="chip">
//               <span className="chip-icon">🎁</span>
//               <h4>Rewards</h4>
//             </div>
//             <div className="chip">
//               <span className="chip-icon">⭐</span>
//               <h4>Feedback</h4>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* RIGHT SECTION */}
//       <div className="right-form-panel">
//         <div className="form-card">
//           <div className="logo-container">
//             <img
//               src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
//               alt="Brand Logo"
//             />
//           </div>

//           {!showOtp ? (
//             <form onSubmit={handleContinue}>
//               <div className="panel-header">
//                 <h2>Welcome Back</h2>
//                 <p>Enter your mobile number to continue your loyalty journey.</p>
//               </div>

//               <div className="input-group">
//                 <label htmlFor="phone-number-field">Mobile Number</label>
//                 <div className="phone-wrapper">
//                   <div className="prefix">+91</div>
//                   <input
//                     id="phone-number-field"
//                     type="tel"
//                     maxLength={10}
//                     placeholder="Enter Number"
//                     value={phone}
//                     disabled={loading}
//                     onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
//                   />
//                 </div>
//               </div>

//               <button 
//                 type="submit" 
//                 className="primary-btn orange-gradient" 
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <div className="spinner"></div>
//                     <span>Sending OTP...</span>
//                   </>
//                 ) : (
//                   <span>Continue →</span>
//                 )}
//               </button>
//             </form>
//           ) : (
//             <form onSubmit={handleVerify} className="otp-fade-in">
//               <div className="panel-header">
//                 <h2>OTP Verification</h2>
//                 <p>Enter verification code sent on +91 {phone}</p>
//               </div>

//               <div className="otp-grid">
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     id={`otp-${index}`}
//                     type="text"
//                     inputMode="numeric"
//                     pattern="[0-9]*"
//                     maxLength={1}
//                     value={digit}
//                     disabled={loading}
//                     onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                     onChange={(e) => handleOtp(e.target.value, index)}
//                   />
//                 ))}
//               </div>

//               <button 
//                 type="submit" 
//                 className="primary-btn teal-gradient" 
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <div className="spinner"></div>
//                     <span>Verifying...</span>
//                   </>
//                 ) : (
//                   <span>Verify &amp; Continue →</span>
//                 )}
//               </button>
//             </form>
//           )}

//           <div className="bottom-credits">
//             Secure dine-in verification system with rewards, loyalty and customer engagement.
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// // WhatsApp business number (jis par user "OTP" bhejega)
// const WA_NUMBER = "919056506757";
// const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent("OTP")}`;

// export default function Login() {
//   const navigate = useNavigate();

//   const [phone, setPhone] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);

//   // स्ट्रिंग में से "DATABASECONNECTED" को हटाकर शुद्ध JSON पार्स करने के लिए हेल्पर फ़ंक्शन
//   const parseCleanJson = async (response) => {
//     const rawText = await response.text();
//     const cleanText = rawText.replace("DATABASECONNECTED", "").trim();
//     return JSON.parse(cleanText);
//   };

//   // --- 1. OPEN WHATSAPP (OTP webhook se aayega, isliye yahan koi API call nahi) ---
//   const openWhatsApp = () => {
//     window.open(WA_LINK, "_blank");
//   };

//   const handleContinue = (e) => {
//     if (e) e.preventDefault();

//     if (phone.length !== 10) {
//       alert("Please enter 10 digit number");
//       return;
//     }

//     openWhatsApp();   // WhatsApp khulega, "OTP" likha hua, user sirf Send dabayega
//     setShowOtp(true); // Saath hi OTP box dikha do
//   };

//   // --- 2. VERIFY OTP API CALL (FormData) - pehle jaisa hi ---
//   const handleVerify = (e) => {
//     if (e) e.preventDefault();
//     const finalOtp = otp.join("");

//     if (finalOtp.length !== 6) {
//       return;
//     }

//     setLoading(true);

//     const formdata = new FormData();
//     formdata.append("mobilenumber", phone);
//     formdata.append("otp", finalOtp);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/otp_varification.php", requestOptions)
//       .then((response) => parseCleanJson(response))
//       .then((result) => {
//         setLoading(false);
//         if (result.status === "success") {
//           // Save Login Status
//           localStorage.setItem("isLoggedIn", "true");

//           // Save User Data
//           localStorage.setItem("userData", JSON.stringify(result.data));

//           navigate("/visit-dashboard", { replace: true });
//         } else {
//           alert(result.message || "wrong otp");
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Verification Error:", error);
//       });
//   };

//   const handleOtp = (value, index) => {
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value.slice(-1);
//     setOtp(newOtp);

//     if (value && index < 5) {
//       document.getElementById(`otp-${index + 1}`)?.focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       document.getElementById(`otp-${index - 1}`)?.focus();
//     }
//   };

//   const handleChangeNumber = () => {
//     setShowOtp(false);
//     setOtp(["", "", "", "", "", ""]);
//   };

//   return (
//     <div className="login-wrapper">
//       <style>{`
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//           font-family: 'Poppins', sans-serif;
//         }

//         body {
//           background: #f8fafc;
//           min-height: 100vh;
//           width: 100%;
//         }

//         .login-wrapper {
//           min-height: 100vh;
//           width: 100%;
//           display: grid;
//           grid-template-columns: 1.1fr 0.9fr;
//         }

//         /* LEFT BRAND PANEL */
//         .left-banner {
//           position: relative;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 40px;
//           background: url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop');
//           background-size: cover;
//           background-position: center;
//         }

//         .banner-overlay {
//           position: absolute;
//           inset: 0;
//           background: linear-gradient(135deg, rgba(15, 23, 42, 0.95), rgba(30, 41, 59, 0.85));
//         }

//         .banner-content {
//           position: relative;
//           z-index: 2;
//           width: 100%;
//           max-width: 500px;
//           color: white;
//         }

//         .banner-content h1 {
//           font-size: clamp(32px, 4vw, 48px);
//           font-weight: 800;
//           line-height: 1.2;
//           margin-bottom: 8px;
//           letter-spacing: -1px;
//         }

//         .banner-content h2 {
//           font-size: clamp(20px, 2.5vw, 28px);
//           color: #f97316;
//           margin-bottom: 20px;
//           font-weight: 700;
//         }

//         .banner-content p {
//           font-size: clamp(14px, 1.5vw, 16px);
//           color: #cbd5e1;
//           line-height: 1.7;
//           margin-bottom: clamp(24px, 4vw, 40px);
//         }

//         .feature-chips {
//           display: flex;
//           gap: 14px;
//           flex-wrap: wrap;
//         }

//         .chip {
//           flex: 1;
//           min-width: 120px;
//           background: rgba(255, 255, 255, 0.06);
//           backdrop-filter: blur(8px);
//           -webkit-backdrop-filter: blur(8px);
//           border: 1px solid rgba(255, 255, 255, 0.1);
//           border-radius: 16px;
//           padding: clamp(12px, 2vw, 20px) 10px;
//           text-align: center;
//           transition: all 0.3s ease;
//         }

//         .chip:hover {
//           transform: translateY(-3px);
//           background: rgba(255, 255, 255, 0.12);
//         }

//         .chip-icon {
//           font-size: clamp(22px, 3vw, 28px);
//           display: block;
//           margin-bottom: 6px;
//         }

//         .chip h4 {
//           font-size: 13px;
//           font-weight: 600;
//           color: #f8fafc;
//         }

//         /* RIGHT FORM PANEL */
//         .right-form-panel {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: #f8fafc;
//           padding: 40px 24px;
//         }

//         .form-card {
//           width: 100%;
//           max-width: 440px;
//           background: white;
//           border-radius: 28px;
//           padding: clamp(24px, 5vw, 40px);
//           box-shadow: 0 20px 40px rgba(15, 23, 42, 0.04);
//           border: 1px solid #f1f5f9;
//         }

//         .logo-container {
//           width: 76px;
//           height: 76px;
//           margin: 0 auto 24px auto;
//           border-radius: 20px;
//           background: #fff7ed;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border: 1px solid #ffedd5;
//         }

//         .logo-container img {
//           width: 42px;
//           height: 42px;
//           object-fit: contain;
//         }

//         .panel-header {
//           text-align: center;
//           margin-bottom: 32px;
//         }

//         .panel-header h2 {
//           font-size: clamp(20px, 3vw, 24px);
//           color: #0f172a;
//           font-weight: 700;
//           margin-bottom: 6px;
//         }

//         .panel-header p {
//           color: #64748b;
//           font-size: 14px;
//         }

//         .input-group {
//           margin-bottom: 24px;
//         }

//         .input-group label {
//           display: block;
//           margin-bottom: 8px;
//           color: #475569;
//           font-size: 13px;
//           font-weight: 600;
//         }

//         .phone-wrapper {
//           height: 54px;
//           border: 2px solid #e2e8f0;
//           border-radius: 14px;
//           display: flex;
//           align-items: center;
//           overflow: hidden;
//           transition: all 0.2s ease;
//           background: #f8fafc;
//         }

//         .phone-wrapper:focus-within {
//           border-color: #f97316;
//           box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1);
//           background: white;
//         }

//         .prefix {
//           padding: 0 14px;
//           color: #475569;
//           font-weight: 600;
//           font-size: 15px;
//           border-right: 1px solid #e2e8f0;
//           height: 100%;
//           display: flex;
//           align-items: center;
//           background: #f1f5f9;
//         }

//         .phone-wrapper input {
//           flex: 1;
//           width: 100%;
//           border: none;
//           outline: none;
//           background: transparent;
//           padding: 0 14px;
//           font-size: 16px;
//           font-weight: 600;
//           color: #0f172a;
//           letter-spacing: 0.5px;
//         }

//         .primary-btn {
//           width: 100%;
//           height: 52px;
//           border: none;
//           border-radius: 14px;
//           color: white;
//           font-size: 15px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//         }

//         .orange-gradient {
//           background: linear-gradient(135deg, #ea580c, #f97316);
//           box-shadow: 0 4px 12px rgba(249, 115, 22, 0.15);
//         }

//         .teal-gradient {
//           background: linear-gradient(135deg, #0d9488, #14b8a6);
//           box-shadow: 0 4px 12px rgba(13, 148, 136, 0.15);
//         }

//         .wa-gradient {
//           background: linear-gradient(135deg, #16a34a, #25d366);
//           box-shadow: 0 4px 12px rgba(37, 211, 102, 0.2);
//         }

//         .primary-btn:hover:not(:disabled) {
//           transform: translateY(-1px);
//           filter: brightness(1.03);
//         }

//         .primary-btn:disabled {
//           opacity: 0.65;
//           cursor: not-allowed;
//         }

//         .wa-icon {
//           width: 20px;
//           height: 20px;
//           fill: white;
//         }

//         /* WHATSAPP STEPS BOX */
//         .wa-steps {
//           background: #f0fdf4;
//           border: 1px solid #bbf7d0;
//           border-radius: 14px;
//           padding: 14px 16px;
//           margin-bottom: 20px;
//         }

//         .wa-steps ol {
//           margin: 0;
//           padding-left: 18px;
//           color: #166534;
//           font-size: 13px;
//           line-height: 1.7;
//           font-weight: 500;
//         }

//         .secondary-actions {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-top: 16px;
//           gap: 12px;
//         }

//         .link-btn {
//           background: none;
//           border: none;
//           padding: 4px 0;
//           font-size: 13px;
//           font-weight: 600;
//           cursor: pointer;
//           color: #16a34a;
//         }

//         .link-btn.muted {
//           color: #64748b;
//         }

//         .link-btn:hover {
//           text-decoration: underline;
//         }

//         .small-note {
//           text-align: center;
//           margin-top: 12px;
//           font-size: 12px;
//           color: #94a3b8;
//         }

//         /* LOADING ANIMATION Spinner */
//         .spinner {
//           width: 18px;
//           height: 18px;
//           border-radius: 50%;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-top: 2px solid white;
//           animation: spin 0.6s linear infinite;
//         }

//         @keyframes spin {
//           100% { transform: rotate(360deg); }
//         }

//         /* OTP INPUT BOXES DESIGN */
//         .otp-fade-in {
//           animation: scaleUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
//         }

//         .otp-grid {
//           display: grid;
//           grid-template-columns: repeat(6, 1fr);
//           gap: 8px;
//           margin: 24px 0;
//         }

//         .otp-grid input {
//           height: 50px;
//           width: 100%;
//           border-radius: 12px;
//           border: 2px solid #e2e8f0;
//           text-align: center;
//           font-size: clamp(16px, 4vw, 20px);
//           font-weight: 700;
//           background: #f8fafc;
//           color: #0f172a;
//           transition: all 0.2s ease;
//         }

//         .otp-grid input:focus {
//           outline: none;
//           border-color: #0d9488;
//           background: white;
//           box-shadow: 0 0 0 4px rgba(13, 148, 136, 0.1);
//         }

//         .bottom-credits {
//           text-align: center;
//           margin-top: 32px;
//           font-size: 12px;
//           color: #94a3b8;
//           line-height: 1.5;
//         }

//         @keyframes scaleUp {
//           from { opacity: 0; transform: scale(0.96) translateY(8px); }
//           to { opacity: 1; transform: scale(1) translateY(0); }
//         }

//         /* RESPONSIVE MEDIA QUERIES */
//         @media (max-width: 992px) {
//           .login-wrapper {
//             grid-template-columns: 1fr;
//           }
//           .left-banner {
//             height: 320px;
//             padding: 30px 20px;
//             text-align: center;
//           }
//           .banner-content {
//             max-width: 600px;
//           }
//           .banner-content p {
//             margin-bottom: 20px;
//           }
//           .feature-chips {
//             justify-content: center;
//             max-width: 460px;
//             margin: 0 auto;
//           }
//           .right-form-panel {
//             padding: 32px 24px;
//           }
//         }

//         @media (max-width: 576px) {
//           .left-banner {
//             height: 220px;
//           }
//           .banner-content h2, .banner-content p, .feature-chips {
//             display: none;
//           }
//           .right-form-panel {
//             padding: 16px 12px;
//             background: white;
//           }
//           .form-card {
//             padding: 24px 16px;
//             border-radius: 20px;
//             box-shadow: none;
//             border: none;
//           }
//           .logo-container {
//             margin-bottom: 16px;
//           }
//           .panel-header {
//             margin-bottom: 24px;
//           }
//           .otp-grid {
//             gap: 4px;
//           }
//           .otp-grid input {
//             height: 44px;
//           }
//         }
//       `}</style>

//       {/* LEFT SECTION */}
//       <div className="left-banner">
//         <div className="banner-overlay"></div>
//         <div className="banner-content">
//           <h1>CountMyVisit</h1>
//           <h2>Feedback Ecosystem</h2>
//           <p>
//             QR based restaurant loyalty platform with rewards, customer engagement, live visit tracking and smart feedback management.
//           </p>
//           <div className="feature-chips">
//             <div className="chip">
//               <span className="chip-icon">📍</span>
//               <h4>Live Visits</h4>
//             </div>
//             <div className="chip">
//               <span className="chip-icon">🎁</span>
//               <h4>Rewards</h4>
//             </div>
//             <div className="chip">
//               <span className="chip-icon">⭐</span>
//               <h4>Feedback</h4>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* RIGHT SECTION */}
//       <div className="right-form-panel">
//         <div className="form-card">
//           <div className="logo-container">
//             <img
//               src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
//               alt="Brand Logo"
//             />
//           </div>

//           {!showOtp ? (
//             <form onSubmit={handleContinue}>
//               <div className="panel-header">
//                 <h2>Welcome Back</h2>
//                 <p>Enter your mobile number to continue your loyalty journey.</p>
//               </div>

//               <div className="input-group">
//                 <label htmlFor="phone-number-field">Mobile Number</label>
//                 <div className="phone-wrapper">
//                   <div className="prefix">+91</div>
//                   <input
//                     id="phone-number-field"
//                     type="tel"
//                     maxLength={10}
//                     placeholder="Enter Number"
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
//                   />
//                 </div>
//               </div>

//               <button type="submit" className="primary-btn wa-gradient">
//                 <svg className="wa-icon" viewBox="0 0 24 24" aria-hidden="true">
//                   <path d="M20.5 3.5A11.9 11.9 0 0012.04 0C5.5 0 .17 5.33.17 11.88c0 2.09.55 4.13 1.59 5.93L0 24l6.35-1.66a11.86 11.86 0 005.69 1.45h.01c6.54 0 11.87-5.33 11.87-11.88 0-3.17-1.23-6.15-3.42-8.41zM12.05 21.8h-.01a9.9 9.9 0 01-5.04-1.38l-.36-.21-3.77.99 1.01-3.67-.24-.38a9.87 9.87 0 01-1.51-5.26c0-5.45 4.44-9.89 9.9-9.89 2.64 0 5.12 1.03 6.98 2.9a9.82 9.82 0 012.89 7c0 5.46-4.44 9.9-9.85 9.9zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.19 5.07 4.47.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35z" />
//                 </svg>
//                 <span>Verify with WhatsApp</span>
//               </button>
//             </form>
//           ) : (
//             <form onSubmit={handleVerify} className="otp-fade-in">
//               <div className="panel-header">
//                 <h2>OTP Verification</h2>
//                 <p>Get your verification code on WhatsApp for +91 {phone}</p>
//               </div>

//               <div className="wa-steps">
//                 <ol>
//                   <li>WhatsApp mein message <b>"OTP"</b> already likha hoga</li>
//                   <li>Bas <b>Send</b> dabayein</li>
//                   <li>Aapko turant OTP mil jayega, yahan daalein</li>
//                 </ol>
//               </div>

//               <button
//                 type="button"
//                 className="primary-btn wa-gradient"
//                 onClick={openWhatsApp}
//               >
//                 <svg className="wa-icon" viewBox="0 0 24 24" aria-hidden="true">
//                   <path d="M20.5 3.5A11.9 11.9 0 0012.04 0C5.5 0 .17 5.33.17 11.88c0 2.09.55 4.13 1.59 5.93L0 24l6.35-1.66a11.86 11.86 0 005.69 1.45h.01c6.54 0 11.87-5.33 11.87-11.88 0-3.17-1.23-6.15-3.42-8.41zM12.05 21.8h-.01a9.9 9.9 0 01-5.04-1.38l-.36-.21-3.77.99 1.01-3.67-.24-.38a9.87 9.87 0 01-1.51-5.26c0-5.45 4.44-9.89 9.9-9.89 2.64 0 5.12 1.03 6.98 2.9a9.82 9.82 0 012.89 7c0 5.46-4.44 9.9-9.85 9.9zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.19 5.07 4.47.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35z" />
//                 </svg>
//                 <span>Open WhatsApp</span>
//               </button>

//               <div className="otp-grid">
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     id={`otp-${index}`}
//                     type="text"
//                     inputMode="numeric"
//                     pattern="[0-9]*"
//                     maxLength={1}
//                     value={digit}
//                     disabled={loading}
//                     onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                     onChange={(e) => handleOtp(e.target.value, index)}
//                   />
//                 ))}
//               </div>

//               <button
//                 type="submit"
//                 className="primary-btn teal-gradient"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <div className="spinner"></div>
//                     <span>Verifying...</span>
//                   </>
//                 ) : (
//                   <span>Verify &amp; Continue →</span>
//                 )}
//               </button>

//               <div className="secondary-actions">
//                 <button type="button" className="link-btn muted" onClick={handleChangeNumber}>
//                   ← Change number
//                 </button>
//                 <button type="button" className="link-btn" onClick={openWhatsApp}>
//                   OTP nahi aaya? Dobara bhejein
//                 </button>
//               </div>

//               <p className="small-note">
//                 WhatsApp mein wahi number use karein jo aapne upar daala hai.
//               </p>
//             </form>
//           )}

//           <div className="bottom-credits">
//             Secure dine-in verification system with rewards, loyalty and customer engagement.
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// WhatsApp business number that the user sends "OTP" to
const WA_NUMBER = "919056506757";
const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent("OTP")}`;

export default function Login() {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);

  // Keep the user signed in: if a valid session already exists, skip the login screen
  useEffect(() => {
    try {
      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      const userData = localStorage.getItem("userData");
      if (isLoggedIn && userData) {
        navigate("/visit-dashboard", { replace: true });
      }
    } catch (err) {
      // Storage unavailable (e.g. private mode): show the login form
    }
  }, [navigate]);

  // Helper: strips the "DATABASECONNECTED" prefix from the response before parsing JSON
  const parseCleanJson = async (response) => {
    const rawText = await response.text();
    const cleanText = rawText.replace("DATABASECONNECTED", "").trim();
    return JSON.parse(cleanText);
  };

  // --- 1. OPEN WHATSAPP (the OTP is sent by the webhook, so no API call is needed here) ---
  const openWhatsApp = () => {
    window.open(WA_LINK, "_blank");
  };

  const handleContinue = (e) => {
    if (e) e.preventDefault();

    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    openWhatsApp();   // Opens WhatsApp with "OTP" prefilled; the user only taps Send
    setShowOtp(true); // Show the OTP entry screen at the same time
  };

  // --- 2. VERIFY OTP API CALL (FormData) ---
  const handleVerify = (e) => {
    if (e) e.preventDefault();
    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      return;
    }

    setLoading(true);

    const formdata = new FormData();
    formdata.append("mobilenumber", phone);
    formdata.append("otp", finalOtp);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };

    fetch("https://countmyvisit.com/Apis/otp_varification.php", requestOptions)
      .then((response) => parseCleanJson(response))
      .then((result) => {
        setLoading(false);
        if (result.status === "success") {
          // Save Login Status
          localStorage.setItem("isLoggedIn", "true");

          // Save User Data
          localStorage.setItem("userData", JSON.stringify(result.data));

          navigate("/visit-dashboard", { replace: true });
        } else {
          alert(result.message || "Incorrect OTP. Please try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Verification Error:", error);
        alert("Unable to verify the OTP right now. Please try again.");
      });
  };

  const handleOtp = (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const handleChangeNumber = () => {
    setShowOtp(false);
    setOtp(["", "", "", "", "", ""]);
  };

  return (
    <div className="login-wrapper">
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: 'Poppins', sans-serif;
        }

        body {
          background: #f8fafc;
          min-height: 100vh;
          width: 100%;
        }

        .login-wrapper {
          min-height: 100vh;
          width: 100%;
          display: grid;
          grid-template-columns: 1.1fr 0.9fr;
        }

        /* LEFT BRAND PANEL */
        .left-banner {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
          background: url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop');
          background-size: cover;
          background-position: center;
        }

        .banner-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.95), rgba(30, 41, 59, 0.85));
        }

        .banner-content {
          position: relative;
          z-index: 2;
          width: 100%;
          max-width: 500px;
          color: white;
        }

        .banner-content h1 {
          font-size: clamp(32px, 4vw, 48px);
          font-weight: 800;
          line-height: 1.2;
          margin-bottom: 8px;
          letter-spacing: -1px;
        }

        .banner-content h2 {
          font-size: clamp(20px, 2.5vw, 28px);
          color: #f97316;
          margin-bottom: 20px;
          font-weight: 700;
        }

        .banner-content p {
          font-size: clamp(14px, 1.5vw, 16px);
          color: #cbd5e1;
          line-height: 1.7;
          margin-bottom: clamp(24px, 4vw, 40px);
        }

        .feature-chips {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
        }

        .chip {
          flex: 1;
          min-width: 120px;
          background: rgba(255, 255, 255, 0.06);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: clamp(12px, 2vw, 20px) 10px;
          text-align: center;
          transition: all 0.3s ease;
        }

        .chip:hover {
          transform: translateY(-3px);
          background: rgba(255, 255, 255, 0.12);
        }

        .chip-icon {
          font-size: clamp(22px, 3vw, 28px);
          display: block;
          margin-bottom: 6px;
        }

        .chip h4 {
          font-size: 13px;
          font-weight: 600;
          color: #f8fafc;
        }

        /* RIGHT FORM PANEL */
        .right-form-panel {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8fafc;
          padding: 40px 24px;
        }

        .form-card {
          width: 100%;
          max-width: 440px;
          background: white;
          border-radius: 28px;
          padding: clamp(24px, 5vw, 40px);
          box-shadow: 0 20px 40px rgba(15, 23, 42, 0.04);
          border: 1px solid #f1f5f9;
        }

        .logo-container {
          width: 76px;
          height: 76px;
          margin: 0 auto 24px auto;
          border-radius: 20px;
          background: #fff7ed;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #ffedd5;
        }

        .logo-container img {
          width: 42px;
          height: 42px;
          object-fit: contain;
        }

        .panel-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .panel-header h2 {
          font-size: clamp(20px, 3vw, 24px);
          color: #0f172a;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .panel-header p {
          color: #64748b;
          font-size: 14px;
        }

        .input-group {
          margin-bottom: 24px;
        }

        .input-group label {
          display: block;
          margin-bottom: 8px;
          color: #475569;
          font-size: 13px;
          font-weight: 600;
        }

        .phone-wrapper {
          height: 54px;
          border: 2px solid #e2e8f0;
          border-radius: 14px;
          display: flex;
          align-items: center;
          overflow: hidden;
          transition: all 0.2s ease;
          background: #f8fafc;
        }

        .phone-wrapper:focus-within {
          border-color: #f97316;
          box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1);
          background: white;
        }

        .prefix {
          padding: 0 14px;
          color: #475569;
          font-weight: 600;
          font-size: 15px;
          border-right: 1px solid #e2e8f0;
          height: 100%;
          display: flex;
          align-items: center;
          background: #f1f5f9;
        }

        .phone-wrapper input {
          flex: 1;
          width: 100%;
          border: none;
          outline: none;
          background: transparent;
          padding: 0 14px;
          font-size: 16px;
          font-weight: 600;
          color: #0f172a;
          letter-spacing: 0.5px;
        }

        .primary-btn {
          width: 100%;
          height: 52px;
          border: none;
          border-radius: 14px;
          color: white;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .orange-gradient {
          background: linear-gradient(135deg, #ea580c, #f97316);
          box-shadow: 0 4px 12px rgba(249, 115, 22, 0.15);
        }

        .teal-gradient {
          background: linear-gradient(135deg, #0d9488, #14b8a6);
          box-shadow: 0 4px 12px rgba(13, 148, 136, 0.15);
        }

        .wa-gradient {
          background: linear-gradient(135deg, #16a34a, #25d366);
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.2);
        }

        .primary-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          filter: brightness(1.03);
        }

        .primary-btn:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }

        .wa-icon {
          width: 20px;
          height: 20px;
          fill: white;
        }

        /* WHATSAPP STEPS BOX */
        .wa-steps {
          background: #f0fdf4;
          border: 1px solid #bbf7d0;
          border-radius: 14px;
          padding: 14px 16px;
          margin-bottom: 20px;
        }

        .wa-steps ol {
          margin: 0;
          padding-left: 18px;
          color: #166534;
          font-size: 13px;
          line-height: 1.7;
          font-weight: 500;
        }

        .secondary-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 16px;
          gap: 12px;
        }

        .link-btn {
          background: none;
          border: none;
          padding: 4px 0;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          color: #16a34a;
        }

        .link-btn.muted {
          color: #64748b;
        }

        .link-btn:hover {
          text-decoration: underline;
        }

        .small-note {
          text-align: center;
          margin-top: 12px;
          font-size: 12px;
          color: #94a3b8;
        }

        /* LOADING ANIMATION Spinner */
        .spinner {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          animation: spin 0.6s linear infinite;
        }

        @keyframes spin {
          100% { transform: rotate(360deg); }
        }

        /* OTP INPUT BOXES DESIGN */
        .otp-fade-in {
          animation: scaleUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .otp-grid {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 8px;
          margin: 24px 0;
        }

        .otp-grid input {
          height: 50px;
          width: 100%;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
          text-align: center;
          font-size: clamp(16px, 4vw, 20px);
          font-weight: 700;
          background: #f8fafc;
          color: #0f172a;
          transition: all 0.2s ease;
        }

        .otp-grid input:focus {
          outline: none;
          border-color: #0d9488;
          background: white;
          box-shadow: 0 0 0 4px rgba(13, 148, 136, 0.1);
        }

        .bottom-credits {
          text-align: center;
          margin-top: 32px;
          font-size: 12px;
          color: #94a3b8;
          line-height: 1.5;
        }

        @keyframes scaleUp {
          from { opacity: 0; transform: scale(0.96) translateY(8px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }

        /* RESPONSIVE MEDIA QUERIES */
        @media (max-width: 992px) {
          .login-wrapper {
            grid-template-columns: 1fr;
          }
          .left-banner {
            height: 320px;
            padding: 30px 20px;
            text-align: center;
          }
          .banner-content {
            max-width: 600px;
          }
          .banner-content p {
            margin-bottom: 20px;
          }
          .feature-chips {
            justify-content: center;
            max-width: 460px;
            margin: 0 auto;
          }
          .right-form-panel {
            padding: 32px 24px;
          }
        }

        @media (max-width: 576px) {
          .left-banner {
            height: 220px;
          }
          .banner-content h2, .banner-content p, .feature-chips {
            display: none;
          }
          .right-form-panel {
            padding: 16px 12px;
            background: white;
          }
          .form-card {
            padding: 24px 16px;
            border-radius: 20px;
            box-shadow: none;
            border: none;
          }
          .logo-container {
            margin-bottom: 16px;
          }
          .panel-header {
            margin-bottom: 24px;
          }
          .otp-grid {
            gap: 4px;
          }
          .otp-grid input {
            height: 44px;
          }
        }
      `}</style>

      {/* LEFT SECTION */}
      <div className="left-banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>CountMyVisit</h1>
          <h2>Feedback Ecosystem</h2>
          <p>
            QR based restaurant loyalty platform with rewards, customer engagement, live visit tracking and smart feedback management.
          </p>
          <div className="feature-chips">
            <div className="chip">
              <span className="chip-icon">📍</span>
              <h4>Live Visits</h4>
            </div>
            <div className="chip">
              <span className="chip-icon">🎁</span>
              <h4>Rewards</h4>
            </div>
            <div className="chip">
              <span className="chip-icon">⭐</span>
              <h4>Feedback</h4>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="right-form-panel">
        <div className="form-card">
          <div className="logo-container">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3075/3075977.png"
              alt="Brand Logo"
            />
          </div>

          {!showOtp ? (
            <form onSubmit={handleContinue}>
              <div className="panel-header">
                <h2>Welcome Back</h2>
                <p>Enter your mobile number to continue your loyalty journey.</p>
              </div>

              <div className="input-group">
                <label htmlFor="phone-number-field">Mobile Number</label>
                <div className="phone-wrapper">
                  <div className="prefix">+91</div>
                  <input
                    id="phone-number-field"
                    type="tel"
                    maxLength={10}
                    placeholder="Enter Number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  />
                </div>
              </div>

              <button type="submit" className="primary-btn wa-gradient">
                <svg className="wa-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.5 3.5A11.9 11.9 0 0012.04 0C5.5 0 .17 5.33.17 11.88c0 2.09.55 4.13 1.59 5.93L0 24l6.35-1.66a11.86 11.86 0 005.69 1.45h.01c6.54 0 11.87-5.33 11.87-11.88 0-3.17-1.23-6.15-3.42-8.41zM12.05 21.8h-.01a9.9 9.9 0 01-5.04-1.38l-.36-.21-3.77.99 1.01-3.67-.24-.38a9.87 9.87 0 01-1.51-5.26c0-5.45 4.44-9.89 9.9-9.89 2.64 0 5.12 1.03 6.98 2.9a9.82 9.82 0 012.89 7c0 5.46-4.44 9.9-9.85 9.9zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.19 5.07 4.47.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35z" />
                </svg>
                <span>Verify with WhatsApp</span>
              </button>
            </form>
          ) : (
            <form onSubmit={handleVerify} className="otp-fade-in">
              <div className="panel-header">
                <h2>OTP Verification</h2>
                <p>Get your verification code on WhatsApp for +91 {phone}</p>
              </div>

              <div className="wa-steps">
                <ol>
                  <li>WhatsApp opens with the message <b>"OTP"</b> prefilled</li>
                  <li>Tap <b>Send</b></li>
                  <li>You will receive your code instantly. Enter it below.</li>
                </ol>
              </div>

              <button
                type="button"
                className="primary-btn wa-gradient"
                onClick={openWhatsApp}
              >
                <svg className="wa-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.5 3.5A11.9 11.9 0 0012.04 0C5.5 0 .17 5.33.17 11.88c0 2.09.55 4.13 1.59 5.93L0 24l6.35-1.66a11.86 11.86 0 005.69 1.45h.01c6.54 0 11.87-5.33 11.87-11.88 0-3.17-1.23-6.15-3.42-8.41zM12.05 21.8h-.01a9.9 9.9 0 01-5.04-1.38l-.36-.21-3.77.99 1.01-3.67-.24-.38a9.87 9.87 0 01-1.51-5.26c0-5.45 4.44-9.89 9.9-9.89 2.64 0 5.12 1.03 6.98 2.9a9.82 9.82 0 012.89 7c0 5.46-4.44 9.9-9.85 9.9zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.19 5.07 4.47.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35z" />
                </svg>
                <span>Open WhatsApp</span>
              </button>

              <div className="otp-grid">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    value={digit}
                    disabled={loading}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    onChange={(e) => handleOtp(e.target.value, index)}
                  />
                ))}
              </div>

              <button
                type="submit"
                className="primary-btn teal-gradient"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner"></div>
                    <span>Verifying...</span>
                  </>
                ) : (
                  <span>Verify &amp; Continue →</span>
                )}
              </button>

              <div className="secondary-actions">
                <button type="button" className="link-btn muted" onClick={handleChangeNumber}>
                  ← Change number
                </button>
                <button type="button" className="link-btn" onClick={openWhatsApp}>
                  Didn't receive it? Resend
                </button>
              </div>

              <p className="small-note">
                Please send the message from the same WhatsApp number you entered.
              </p>
            </form>
          )}

          <div className="bottom-credits">
            Secure dine-in verification system with rewards, loyalty and customer engagement.
          </div>
        </div>
      </div>
    </div>
  );
}